export const DISCOVER_REWARD_BENEFITS_URL_STRING =
    'https://support.vividseats.com/support/solutions/articles/11000106875-vivid-seats-rewards'
export const GET_THE_APP_URL_STRING = 'https://corporate.vividseats.com/app/'

export const BUTTON_LABELS = {
    getApp: 'Get The App',
    discoverRewardBenefits: 'Discover Rewards Benefits',
}
